import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export function useAutoLogout(timeout = 10 * 60 * 1000) {
  const router = useRouter()

  let timer = null

  const logout = () => {
    console.log("User logged out due to inactivity")

    // clear auth (adjust to your store)
    localStorage.removeItem('token')

    router.push('/login')
  }

  const resetTimer = () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(logout, timeout)
  }

  const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart']

  const addListeners = () => {
    events.forEach(event => {
      window.addEventListener(event, resetTimer)
    })
  }

  const removeListeners = () => {
    events.forEach(event => {
      window.removeEventListener(event, resetTimer)
    })
  }

  onMounted(() => {
    addListeners()
    resetTimer()
  })

  onUnmounted(() => {
    removeListeners()
    clearTimeout(timer)
  })
}
